import { useEffect, useState } from 'react';
import {
  loadLotteryData,
  LOTTERY_CACHE_TTL_MS,
  readLotteryCache
} from './lotteryData';

export function useLotteryData(game) {
  const [state, setState] = useState(() => {
    const cached = readLotteryCache(game);
    return {
      data: cached?.data ?? null,
      loading: !cached,
      error: null
    };
  });

  useEffect(() => {
    let active = true;
    const cached = readLotteryCache(game);
    setState({
      data: cached?.data ?? null,
      loading: !cached,
      error: null
    });

    const update = () => {
      loadLotteryData(game)
        .then((data) => {
          if (active) {
            setState({ data, loading: false, error: null });
          }
        })
        .catch((error) => {
          if (active) {
            setState((current) => ({
              ...current,
              loading: !current.data,
              error
            }));
          }
        });
    };

    const receiveCacheUpdate = (event) => {
      if (active && event.detail?.game === game) {
        setState({ data: event.detail.data, loading: false, error: null });
      }
    };
    const refreshWhenVisible = () => {
      if (document.visibilityState === 'visible') {
        update();
      }
    };

    window.addEventListener('lottery-data-updated', receiveCacheUpdate);
    document.addEventListener('visibilitychange', refreshWhenVisible);
    const refreshTimer = window.setInterval(
      refreshWhenVisible,
      LOTTERY_CACHE_TTL_MS
    );
    update();

    return () => {
      active = false;
      window.clearInterval(refreshTimer);
      window.removeEventListener('lottery-data-updated', receiveCacheUpdate);
      document.removeEventListener('visibilitychange', refreshWhenVisible);
    };
  }, [game]);

  return state;
}
